<script>
import { get } from 'lodash'
// import reduceWithSeparator from '@/helpers/reduce-with-separator'

const types = {
  clinic: 'Clínica Médica',
  office: 'Consultório Médico',
  hospital: 'Hospital',
  laboratory: 'Labotarório',
  others: 'Outros'
}

const parseType = (type) => {
  return get(types, type, 'Outros')
}

export default {
  name: 'agendas-search-results-specialities',
  computed: {
    typeClinic () {
      return parseType(this.companyType)
    },
    // não tulizado neste nova busca
    getSpecialities () {
      // return reduceWithSeparator(this.specialities, 'name')
    }
  },
  props: {
    companyType: {
      type: String,
      default: ''
    },
    companyName: {
      type: String,
      default: ''
    },
    professionalName: {
      type: String,
      default: ''
    },
    specialities: {
      type: String,
      default: ''
    }
  }
}
</script>

<template lang="pug">
  div
    .info(v-if="professionalName === companyName") {{ typeClinic }}
    .info(v-if="professionalName !== companyName") {{ companyName}}  &mdash; {{ typeClinic }}
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/specialities/specialities.vue